/**
 * Browser automation / headless-environment signals.
 * Signal names must stay aligned with the backend scoring contract.
 */
export async function detectAutomation(): Promise<string[]> {
  if (typeof window === 'undefined' || typeof navigator === 'undefined') {
    return []
  }

  const signals: string[] = []

  if (navigator.webdriver === true) {
    signals.push('webdriver')
  }

  const chromeObj = (window as Window & { chrome?: { runtime?: unknown } }).chrome
  if (chromeObj != null && chromeObj.runtime != null) {
    signals.push('chrome_runtime')
  }

  const w = window as Window & { __playwright?: unknown; __pw_manual?: unknown }
  if (w.__playwright !== undefined || w.__pw_manual !== undefined) {
    signals.push('playwright_flag')
  }

  try {
    if (navigator.plugins && navigator.plugins.length === 0) {
      signals.push('no_plugins')
    }
  } catch {
    // Ignore unsupported plugin access.
  }

  if (!navigator.languages || navigator.languages.length === 0) {
    signals.push('no_languages')
  }

  try {
    const perm = await navigator.permissions?.query({
      name: 'notifications' as PermissionName,
    })
    if (
      perm &&
      perm.state === 'denied' &&
      typeof Notification !== 'undefined' &&
      Notification.permission === 'default'
    ) {
      signals.push('permission_anomaly')
    }
  } catch {
    // Ignore unsupported Permissions API / browser denials.
  }

  return Array.from(new Set(signals))
}
